<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <textarea
        :disabled="
          $parent.$parent.projectDisabled ||
            $parent.$parent.project.UF_IS_BLOCK === 1 ||
            isPurchasedListCoordinated
        "
        type="text"
        class="i-main-style t-co-executor-style t-dop-style"
        style="min-width: 600px;"
        v-model="$parent.project.UF_PLACE_INDUSTRIAL_EQUIPMENT"
      />
    </div>
    <button
      type="button"
      v-if="!$parent.$parent.projectDisabled &&
            $parent.$parent.project.UF_IS_BLOCK !== 1 &&
            !isPurchasedListCoordinated"
      @click="updateField()"
      class="btn btn-success"
    >
      Сохранить
    </button>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";

export default {
  name: "uf_place_industrial_equipment",
  computed: {
    isPurchasedListCoordinated() {
      const list =
        this.$parent && this.$parent.project && this.$parent.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          (el.UF_TYPE_PAGE === "list_of_purhased_10_01") &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    }
  },
  methods: {
    updateField(){
      console.log("XX");
      ProjectsService.editProjectField(
        this.$route.params.id,
        "UF_PLACE_INDUSTRIAL_EQUIPMENT",
        {
          VALUE: this.$parent.project.UF_PLACE_INDUSTRIAL_EQUIPMENT
        }
      ).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
          return;
        } else {
          this.$toasted.show(
            'Информация о месте эксплуатации промышленного оборудования успешно изменена',
            {
              theme: "green",
              position: "bottom-right",
              duration: 3000
            }
          );
        }
      }, this);
    }
  }
};
</script>

<style scoped></style>
